"use strict";

class SuperPublicHolidaySyncConfigsController {

    constructor(
        Upload,
        SSHttpService,
        SSUtilService,
        SSAlertService,
        SSConfigService,
        SSUserService,
        OTPService,
        SSDateService,
        SSConfirmationService
    ) {
        const self = this;

        self.Upload = Upload;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSDateService = SSDateService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        if (self.SSUserService.isSuper() && self.SSUserService.hasPermission('PUBLIC_HOLIDAY_SYNC_CONFIG_MANAGE')) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.URL_BASE = 'sec/super/public-holiday-sync-configurations';

        self.syncConfigs = null;
        self.selectedSyncConfig = null;
        self.syncConfigViewMode = false;
        self.syncConfigEditMode = false;
        self.syncConfigParams = {};
        self.formErrors = {};

        self.headerRows = [];
        self.yearlyMonth = null;
        self.yearlyDay = null;

        self.weekdayOptions = [
            {value: 1, label: '1 - Monday'},
            {value: 2, label: '2 - Tuesday'},
            {value: 3, label: '3 - Wednesday'},
            {value: 4, label: '4 - Thursday'},
            {value: 5, label: '5 - Friday'},
            {value: 6, label: '6 - Saturday'},
            {value: 7, label: '7 - Sunday'}
        ];

        self.dayOfMonthOptions = [];
        for (let i = 1; i <= 31; i++) self.dayOfMonthOptions.push(i);

        self.monthOptions = [
            {value: 1, label: '01 - Jan'}, {value: 2, label: '02 - Feb'},
            {value: 3, label: '03 - Mar'}, {value: 4, label: '04 - Apr'},
            {value: 5, label: '05 - May'}, {value: 6, label: '06 - Jun'},
            {value: 7, label: '07 - Jul'}, {value: 8, label: '08 - Aug'},
            {value: 9, label: '09 - Sep'}, {value: 10, label: '10 - Oct'},
            {value: 11, label: '11 - Nov'}, {value: 12, label: '12 - Dec'}
        ];

        self.getSyncConfigs();
    }

    //-------------------------------------------

    getSyncConfigs() {
        const self = this;

        loading(true);
        self.SSHttpService.getAPIRequest(self.URL_BASE).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.syncConfigs = response.data.public_holiday_sync_configurations || [];
        });
    }

    // AngularJS 1.x binds <input type="time"> ng-model as a Date object.
    // Backend wants H:i:s. Convert both ways at the form boundary.
    parseExecutionTime(value) {
        if (!value) return null;
        if (value instanceof Date) return value;
        const parts = String(value).split(':');
        if (parts.length < 2) return null;
        const d = new Date(1970, 0, 1);
        d.setHours(parseInt(parts[0]) || 0);
        d.setMinutes(parseInt(parts[1]) || 0);
        d.setSeconds(parts[2] ? parseInt(parts[2]) : 0);
        d.setMilliseconds(0);
        return d;
    }

    formatExecutionTime(value) {
        if (!value) return '';
        if (value instanceof Date) {
            const pad = (n) => String(n).padStart(2, '0');
            return pad(value.getHours()) + ':' + pad(value.getMinutes()) + ':' + pad(value.getSeconds());
        }
        return value;
    }

    executionDayDisplay(config) {
        if (!config || config.execution_day == null || config.execution_day === '') {
            return '--';
        }
        const interval = config.refresh_interval;
        const day = parseInt(config.execution_day);
        if (interval === 'daily') {
            return 'N/A';
        }
        if (interval === 'weekly') {
            const labels = ['', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
            return labels[day] || day;
        }
        if (interval === 'monthly') {
            return 'Day ' + day;
        }
        if (interval === 'yearly') {
            const month = Math.floor(day / 100);
            const dom = day % 100;
            const monthLabels = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            return (monthLabels[month] || month) + ' ' + dom;
        }
        return day;
    }

    refreshIntervalChanged() {
        const self = this;
        const interval = self.syncConfigParams.refresh_interval;
        if (interval === 'daily') {
            self.syncConfigParams.execution_day = null;
        } else if (interval === 'yearly') {
            const day = parseInt(self.syncConfigParams.execution_day) || 0;
            self.yearlyMonth = Math.floor(day / 100) || null;
            self.yearlyDay = (day % 100) || null;
        }
    }

    yearlyMonthOrDayChanged() {
        const self = this;
        const m = parseInt(self.yearlyMonth) || 0;
        const d = parseInt(self.yearlyDay) || 0;
        if (m && d) {
            self.syncConfigParams.execution_day = m * 100 + d;
        }
    }

    //-------------------------------------------

    addHeaderRow() {
        this.headerRows.push({key: '', value: ''});
    }

    removeHeaderRow(index) {
        this.headerRows.splice(index, 1);
    }

    headerRowsToObject() {
        const obj = {};
        (this.headerRows || []).forEach(function (row) {
            if (row.key) {
                obj[row.key] = row.value;
            }
        });
        return Object.keys(obj).length ? obj : null;
    }

    headerObjectToRows(headers) {
        if (!headers || typeof headers !== 'object') {
            return [];
        }
        return Object.keys(headers).map(function (k) {
            return {key: k, value: headers[k]};
        });
    }

    //-------------------------------------------

    setSyncConfigViewMode(mode, syncConfig) {
        const self = this;

        self.formErrors = {};

        if (mode) {
            self.selectedSyncConfig = syncConfig || null;
            if (!self.selectedSyncConfig) {
                self.setSyncConfigEditMode(true);
            } else {
                self.syncConfigParams = angular.copy(syncConfig);
                self.syncConfigParams.execution_time = self.parseExecutionTime(self.syncConfigParams.execution_time);
                self.headerRows = self.headerObjectToRows(syncConfig.data_source_headers);
                self.refreshIntervalChanged();
                self.setSyncConfigEditMode(false);
            }
        } else {
            self.selectedSyncConfig = null;
            self.syncConfigParams = {};
            self.headerRows = [];
            self.setSyncConfigEditMode(false);
        }

        self.syncConfigViewMode = !!mode;
    }

    setSyncConfigEditMode(mode) {
        const self = this;
        self.formErrors = {};

        if (mode) {
            if (self.selectedSyncConfig) {
                self.syncConfigParams = angular.copy(self.selectedSyncConfig);
                self.syncConfigParams.execution_time = self.parseExecutionTime(self.syncConfigParams.execution_time);
                self.headerRows = self.headerObjectToRows(self.selectedSyncConfig.data_source_headers);
                self.refreshIntervalChanged();
            } else {
                self.syncConfigParams = self.syncConfigParams || {};
                self.headerRows = self.headerRows || [];
            }
        }

        self.syncConfigEditMode = !!mode;
    }

    //-------------------------------------------

    saveSyncConfig() {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
            self._saveSyncConfig();
        });
    }

    _saveSyncConfig() {
        const self = this;
        self.SSAlertService.clear();

        if (!self.syncConfigParams) {
            return;
        }

        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#syncConfigForm'))) {
            self.SSAlertService.danger('Please correct the following errors before you proceed.');
            return;
        }

        const params = angular.copy(self.syncConfigParams);
        params.is_enabled = !!params.is_enabled;
        params.execution_time = self.formatExecutionTime(params.execution_time);
        params.data_source_headers = self.headerRowsToObject();

        let url = self.URL_BASE + '/';

        const responseHandler = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.formErrors = self.SSHttpService.parseErrors(response) || {};
                if (response.sub_code == 412002) {
                    self.formErrors.country_code = self.formErrors.country_code
                        || (response.message || 'A configuration for this country already exists.');
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            const newConfig = response.data.public_holiday_sync_configuration || response.data;
            const existing = self.selectedSyncConfig;

            if (existing && existing.id) {
                angular.merge(existing, newConfig);
            } else {
                self.syncConfigs = self.syncConfigs || [];
                self.syncConfigs.push(newConfig);
            }

            self.SSAlertService.success('Success!', 'Sync configuration saved.');
            self.setSyncConfigViewMode(true, newConfig);
        };

        loading(true);
        if (params.id) {
            url += params.id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    //-------------------------------------------

    toggleEnabled(syncConfig) {
        const self = this;
        const target = !syncConfig.is_enabled;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
            const url = self.URL_BASE + '/' + syncConfig.id;
            const params = angular.copy(syncConfig);
            params.is_enabled = target;

            loading(true);
            self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                const updated = response.data.public_holiday_sync_configuration || response.data;
                angular.merge(syncConfig, updated);
                self.SSAlertService.success('Success!',
                    'Sync ' + (target ? 'enabled' : 'disabled') + ' for ' +
                    self.SSConfigService.getCountryName(syncConfig.country_code) + '.');
            });
        });
    }

    //-------------------------------------------

    triggerSync(syncConfig) {
        const self = this;
        if (!syncConfig || !syncConfig.id) return;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
            const url = self.URL_BASE + '/' + syncConfig.id + '/trigger-sync';

            loading(true);
            self.SSHttpService.postAPIRequest(url, {}).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                const updated = response.data.public_holiday_sync_configuration;
                if (updated) {
                    angular.merge(syncConfig, updated);
                }

                const result = response.data.sync_result || {};
                if (result.status === 'success') {
                    self.SSAlertService.success('Sync complete!',
                        'Synced ' + (result.rows == null ? '?' : result.rows) +
                        ' rows from ' + (syncConfig.data_source_url || 'source') + '.');
                } else {
                    self.SSAlertService.danger('Sync failed',
                        result.error || 'Sync failed. Check the configuration and try again.');
                }
            });
        });
    }

    //-------------------------------------------

    deleteSyncConfig(id) {
        const self = this;
        if (!id) return;

        self.SSConfirmationService.getConfirmed(
            'Confirmation!',
            'Are you sure you want to delete this sync configuration?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                const url = self.URL_BASE + '/' + id;

                loading(true);
                self.SSHttpService.deleteAPIRequest(url, {}).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    jQuery.each(self.syncConfigs, function (i, o) {
                        if (o.id == id) {
                            self.syncConfigs.splice(i, 1);
                            return false;
                        }
                    });
                    self.SSAlertService.success('Success!', 'Sync configuration deleted.');
                });
            }
        );
    }

}

SuperPublicHolidaySyncConfigsController.$inject = [
    'Upload',
    'SSHttpService',
    'SSUtilService',
    'SSAlertService',
    'SSConfigService',
    'SSUserService',
    'OTPService',
    'SSDateService',
    'SSConfirmationService'
];
app.controller('SuperPublicHolidaySyncConfigsController', SuperPublicHolidaySyncConfigsController);
